import { Plus, Trash2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const StepManifestacoes = ({ manifestacoes = [], onChange, onSave, readOnly }) => {
  const addItem = () => onChange([...manifestacoes, { descricao: "", localizacao: "", intensidade: "", evolucao: "", narrativa: "", fotos: [] }]);
  const updateItem = (index, field, value) => onChange(manifestacoes.map((item, i) => i === index ? { ...item, [field]: value } : item));
  const removeItem = (index) => onChange(manifestacoes.filter((_, i) => i !== index));

  return (
    <Card>
      <CardHeader><CardTitle>Manifestações Observadas</CardTitle></CardHeader>
      <CardContent className="space-y-6">
        {manifestacoes.map((item, index) => (
          <div key={index} className="rounded-lg border p-4 space-y-3">
            <div className="flex justify-between items-center">
              <p className="font-medium">Manifestação {index + 1}</p>
              {!readOnly && <button onClick={() => removeItem(index)} className="text-red-600"><Trash2 size={16} /></button>}
            </div>
            <div><Label>Descrição</Label><Input value={item.descricao || ""} disabled={readOnly} onChange={(e) => updateItem(index, "descricao", e.target.value)} /></div>
            <div><Label>Localização</Label><Input value={item.localizacao || ""} disabled={readOnly} onChange={(e) => updateItem(index, "localizacao", e.target.value)} /></div>
            <div><Label>Intensidade</Label><Input value={item.intensidade || ""} disabled={readOnly} onChange={(e) => updateItem(index, "intensidade", e.target.value)} /></div>
            <div><Label>Evolução</Label><Input value={item.evolucao || ""} disabled={readOnly} onChange={(e) => updateItem(index, "evolucao", e.target.value)} /></div>
            <div><Label>Narrativa</Label><Textarea value={item.narrativa || ""} disabled={readOnly} onChange={(e) => updateItem(index, "narrativa", e.target.value)} /></div>
          </div>
        ))}
        {!readOnly && <Button variant="outline" onClick={addItem}><Plus size={16} className="mr-2" />Adicionar manifestação</Button>}
        {!readOnly && <Button onClick={onSave}>Salvar</Button>}
      </CardContent>
    </Card>
  );
};

export default StepManifestacoes;
